<div [formGroup]="actionsForm">
  <div>
    <div class="kt-portlet__head">
      <div class="kt-portlet__head-progress">
        @if (viewLoading) {
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        }
      </div>
      <div class="kt-portlet__head-label kt-modal-header">
        <div class="kt-header-title">
          <span class="kt-portlet__head-title">{{ 'actions.title' | translate }}</span>
          <span class="kt-portlet__head-icon kt-hide">
            <i class="la la-gear"></i>
          </span>
        </div>
        <div>
          <button [attr.aria-label]="'aria.close_dialog' | translate" mat-icon-button (click)="closeDialog()">
            <mat-icon>clear</mat-icon>
          </button>
        </div>
      </div>
    </div>
    <div class="kt-form">
      <div class="kt-portlet__body">
        <app-alert-message-box [errorMessage] = "errorMessage" ></app-alert-message-box>
        @for (item of actionsFormArray; track item; let i = $index) {
          <div formArrayName="actions">
            <uw-action-item [index]="i" [actionsForm]="actionsForm"></uw-action-item>
          </div>
        }
      </div>
      <div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit text-right footer-sidebyside">
        <div class="kt-form__actions kt-form__actions--sm">
          <button mat-button color="danger" (click)="closeDialog()">{{ "employee_search.employee_detail_form.cancel_btn" | translate }}</button>&nbsp;
          <button (click)="saveChanges()" cdkFocusInitial [disabled]="viewLoading || disableSave" type="button" class="btn btn-primary">
            <i class="la la-check"></i>
            <span class="kt-hidden-mobile">{{ "employee_search.employee_detail_form.save_btn" | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
